import { ScenarioCard } from '@/components/scenario-card';
import { ScenarioCardsRow } from '@/components/scenario-card-row';
import { View } from '@/components/ui/tw-wrappers';
import { SCENARIO_TYPES } from '@/constants/scenarios';
import { Country } from '@/types/country';
import { TransferPair } from '@/types/transfer-pair';

interface ComparisonResultsProps {
  data: TransferPair;
  countries: Country[];
  loading: boolean;
}

export function ComparisonResults({ data, countries, loading }: ComparisonResultsProps) {
  // const isLoggedIn = useAuthStore(s => s.isLoggedIn);

  // const scenarios = SCENARIO_TYPES.filter(type => isLoggedIn || type !== 'alsoThere').map(type => ({
  //   type,
  //   element: <ScenarioCard type={type} data={data} />,
  // }));

  const scenarios = SCENARIO_TYPES.filter(type => type !== 'alsoThere').map(type => ({
    type,
    element: <ScenarioCard type={type} data={data} />,
  }));

  return (
    <View>
      <ScenarioCardsRow scenarios={scenarios} />
      {/* <View className='flex-col md:flex-row' style={{ gap: 16, marginTop: 24 }}>
        <View className='md:w-1/2'>
          <ReportForm data={data} countries={countries} disabled={loading} modelType='compare' />
        </View>
        <View className='md:w-1/2 md:flex-1'>
          <Contact />
        </View>
      </View> */}
    </View>
  );
}
